import { ITask } from "@rentiohq/shared-frontend/dist/types/task.types";
import { DocumentOverview } from "../../../../components/Documents";

interface IProps {
  taskId: number;
  task: ITask;
}

export const TaskDocumentsOverview = (props: IProps) => {
  const { task } = props;

  return (
    <DocumentOverview
      extraFilterData={{ taskId: { eq: task.id } }}
      passPropsDocumentDetail={{ taskId: task.id }}
      withTemplates={false}
    />
  );
};
